import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'tf-core-fb-preview-footer',
  templateUrl: './fb-preview-footer.component.html',
  styleUrls: ['./fb-preview-footer.component.css']
})
export class FbCorePreviewFooterComponent implements OnInit {
    @Input() disableSubmit: boolean;
    @Input() readonly: boolean;

    @Output() onSubmit: EventEmitter<null> = new EventEmitter<null>();
    @Output() onClose: EventEmitter<null> = new EventEmitter<null>();

    constructor(
    ) { }

    ngOnInit(): void {
    }

    public submit(event: MouseEvent): void {
        event.preventDefault();

        this.onSubmit.emit();
    }

    public close(event: MouseEvent): void {
        event.preventDefault();

        this.onClose.emit();
    }

}
